import request from "@/utils/request";

// 收藏或取消收藏
export const  addOrCancelCollect =(data) =>{
    return request({
        url: "/businessservice/collect/addOrCancel",
        method:"post",
        data: data
    })
}

// 判断是否收藏
export const  judgeIsCollect =(data) =>{
    return request({
        url: "/businessservice/collect/isCollect",
        method:"post",
        data: data
    })
}

// 查询收藏列表（按分类）
export const  listCollect =(data) =>{
    return request({
        url: "/businessservice/collect/list",
        method:"post",
        data: data
    })
}